<template lang='pug'>
v-layout.column
  h1.display-1.font-weight-black.green--text.text--darken-3 自動メール
  TheNav.mb-3
  v-layout(row wrap)
    v-flex.xs12
      v-card.mb-4
        v-card-text.grey.lighten-3
          | 下記は問い合わせのあったお客様のHP訪問履歴・閲覧履歴情報です。（反響の詳細や個人情報は従来どおりの方法で確認して下さい）
      TheCustomer(storeModule='conversion_logs_auto_mail', baseColor='blue')
      TheAutoMail
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ResponseMixin from '../../libs/ResponseMixin'
import TheNav from '../../components/conversion_logs/TheNav'
import TheCustomer from '../../components/conversion_logs/TheCustomer'
import TheAutoMail from '../../components/conversion_logs/TheAutoMail'

export default {
  name: 'ConversionLogsAutoMail',
  components: {
    TheCustomer,
    TheNav,
    TheAutoMail,
  },
  mixins: [ResponseMixin],
  computed: {
    ...mapGetters('conversion_logs_auto_mail', [
    ]),
  },

  async created() {
    await this.initState()
    await this.actionFetch()
  },

  async beforeDestroy() {
    await this.initState()
  },

  methods: {
    ...mapActions('conversion_logs_auto_mail', [
      'initState',
      'fetch',
    ]),

    async actionFetch() {
      const response = await this.fetch(this.$route.params)
      if (!this.chkResponse(response)) {
        return
      }
    },
  },
}
</script>

<style lang='scss' scoped>
</style>
